
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getTaskstatus} from 'sr/utils/api/masterData/taskstatus/getTaskstatus'
export const fetchtaskstatus = createAsyncThunk(
  'getTaskstatus',
  async () => {
    const response = await getTaskstatus()
    return response?.data
  }
)


